import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StringHelperService {
  notAllowedSpecialChars(str: string) {
    const specialChars = /[`#&*+:"\\|<>\/?]/;

    return specialChars.test(str);
  }
}
